var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"justify-center"},[_vm._v("Merci !")])
}
var staticRenderFns = []

export { render, staticRenderFns }